import React, {useState, useEffect} from 'react'
import CategoryApi from '../api/CategoryApi';
import ContactDropdown from '../component/dropdown/ContactDropdown';

const CategoryForm = ({categoryId, onSubmits, toogle }) => {
    const nonce = devsAccountingApi.nonce;
    const [state, setState] = useState({
        name: "",
        type: "",
        nonce: nonce,
    });
    const [loading, setLoading] = useState(false); // Loading state added
    const [message, setMessage] = useState("");
    const [fetchData, setFetchingData] = useState(false);
    const [errors, setErrors] = useState({});



    useEffect(() => {
        if(categoryId){
            getCategory(categoryId);
        }
    }, [categoryId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
            setState({
                ...state,
                [name]: value,
            });
    };

    const getCategory = async (categoryId) => {
        setFetchingData(true);
        const res = await CategoryApi.show(categoryId);
        if(res){
            setFetchingData(false);
            setState(res);
        }
    };

    const itemOptions =[
        { value: 'item', label: 'Item' },
        { value: 'income', label: 'Income' },
        { value: 'expense', label: 'Expense' },
    ]

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true); // Set loading state to true when form is submitted
        categoryId ? (state.id = categoryId) : "";
        const res = await CategoryApi.save(state);
        setErrors('');
        if (res.errors) {
            setErrors(res.errors);
            setLoading(false);
        } else {
            setMessage(res.message);
            setLoading(false);
            onSubmits();
            toogle();
        }
    };

  return (
    <div>
        {message &&
            <div className="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3" role="alert">
                <p className="font-bold">{message}</p>
            </div>
        }
        {!fetchData ?
            <section className="p-6 mx-auto">
                <form onSubmit={handleSubmit}>
                    <div className='grid grid-cols-2'>
                        <div>
                            <h2 className="text-lg font-semibold text-gray-700 capitalize dark:text-white">{categoryId ? 'Edit' : 'Add'}  Category</h2>
                        </div>
                        <div className="flex justify-end">
                            <button type='submit' className="px-6 py-2 leading-5 text-white transition-colors duration-200 transform bg-gray-700 rounded-md hover:bg-gray-600 focus:outline-none focus:bg-gray-600">
                                {loading ? 'Submitting...' : 'Submit'} {/* Display 'Submitting...' when loading, 'Submit' otherwise */}
                            </button>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 gap-6 mt-4 ">
                        <div className="">
                            <label className="text-gray-700 dark:text-gray-200" htmlFor="name">Name</label>
                            <input id="name" type="text" className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                                name="name" value={state.name} onChange={handleChange} />
                            {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
                        </div>
                        <div className="">
                            <label className="text-gray-700 dark:text-gray-200" required htmlFor="type">Type</label>
                            <ContactDropdown options={itemOptions} onSelectChange={handleChange} name="type" selectedValue={state.type} />
                            {errors.type && <p className="text-red-500 text-xs mt-1">{errors.type}</p>}
                        </div>
                    </div>
                </form>
            </section>
            : <div className='m-auto'><p className='text-2xl text-bold text-center'>Loading...</p> </div>}
    </div>
  )
}

export default CategoryForm